import { APIClient } from "./axiosClient";
import { IPackage } from "./types/_ads";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";

const api = new APIClient();

const path = "/plans";
const AdsApi = {
  plans(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getPlan(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  
  deletePlan(id: any) {
    return api.delete(`${path}/${id}`);
  },
  
  postPlan(dataForm: any) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putPlan(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
};

export default AdsApi;
